if (!customElements.get('msp-oven-tech-variant')) {
  customElements.define(
    'msp-oven-tech-variant',
    class MSPOvenTechVariant extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.showVariant(this.dataset.selectedVariantId);

        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          this.showVariant(event?.data?.variant?.id);
        });
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      showVariant(variantId) {
        if (!variantId) return;
        const mapping = this.querySelector(`[data-msp-variant-id="${String(variantId)}"]`);
        if (!mapping) return;

        const groupKey = mapping.dataset.mspGroupKey;
        const summary = this.querySelector(`[data-msp-summary-group="${groupKey}"]`);
        const details = this.querySelector(`[data-msp-details-group="${groupKey}"]`);
        const summaryTarget = this.querySelector('[data-msp-current-summary]');
        const detailsTarget = this.querySelector('[data-msp-tech-details]');
        if (!summary || !details || !summaryTarget || !detailsTarget) return;

        summaryTarget.replaceChildren(summary.content.cloneNode(true));
        detailsTarget.content.replaceChildren(details.content.cloneNode(true));
        this.dataset.selectedVariantId = String(variantId);
        document.dispatchEvent(new CustomEvent('msp:technical-details-updated'));
      }
    }
  );
}
